import React, { useState, useEffect } from "react";
import axios from "axios";
import LeadDbService from "../Services/LeadDbService";
import { getIcons } from "../Constant/Constant";

const LeadDeals = ({ docId }) => {
  const icons = getIcons();
  const [activeTab, setActiveTab] = useState("On Going");
  const [deals, setDeals] = useState({
    ongoingDeals: [],
    completedDeals: [],
    lostDeals: [],
  });

  // useEffect(() => {
  //   axios
  //     .get(
  //       `https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/getDealsByLeadId?leadDocId=${docId}`
  //     )
  //     .then((response) => {
  //       setDeals(response.data);
  //       console.log(dateTimeConversion)
  //     })
  //     .catch((error) => {
  //       console.error("There was an error fetching the deals!", error);
  //     });
  // }, [docId]);

  useEffect(() => {
    LeadDbService.fetchDealsByLeadId(docId)
      .then((response) => {
        setDeals(response.data);
        console.log("Deals fetched:", response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the deals!", error);
      });
  }, [docId]);
  const tabs = ["On Going", "Completed", "Lost"];
  const dateTimeConversion = (item) => {
    let dateMDY = "";

    let date = new Date(item?.dealFollowup?.updatedTimestamp);
    console.log(date);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === today.getTime()) {
      dateMDY = "Today";
    } else if (inputDate.getTime() === yesterday.getTime()) {
      dateMDY = "Yesterday";
    } else {
      dateMDY = `${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}`;
    }

    console.log(`date${dateMDY}`);
    return dateMDY;
  };
  return (
    <div className="bg-white shadow-md rounded w-full h-80 3xl:h-[320px] 4xl:h-[416px]">
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Lead Deals</h1>
        <div className="flex  border-gray-300 border-2 px-3 w-full text-lg rounded-md justify-between ">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-2 px-4 ${
                activeTab === tab
                  ? "border-b-2 border-green-500 h-10 font-bold whitespace-nowrap text-green-500"
                  : "text-gray-500"
              }`}
            >
              {tab} (
              {deals[`${tab.replace(" ", "").toLowerCase()}Deals`]
                ? deals[`${tab.replace(" ", "").toLowerCase()}Deals`].length
                : 0}
              )
            </button>
          ))}
        </div>

        <div className="flex flex-col h-44 4xl:h-[240px] mt-2 w-full items-center overflow-y-auto custom-scrollbar">
          {activeTab === "On Going" &&
            (deals.ongoingDeals && deals.ongoingDeals.length > 0 ? (
              deals.ongoingDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 4xl:m-10  p-4 shadow-md mb-4 "
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet
                    <span className="text-gray-400 font-light text-lg">
                      {" "}
                      Approx
                    </span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal?.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal?.property?.name}</p>
                      <p className="text-gray-500">
                        {deal?.currentStage?.name}
                      </p>
                    </div>
                    <div>
                      <p className="font-bold">
                        {deal?.dealFollowup?.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal?.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">On Going</p>
                      {/* <p className="font-bold">{dateTimeConversion(deal?.dealFollowup?.scheduledTime)}</p> */}
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal?.dealFollowup?.scheduledTime
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="border rounded-lg w-5/6 p-4 shadow-md">
                <p>No ongoing deals.</p>
              </div>
            ))}

          {activeTab === "Completed" &&
            (deals.completedDeals && deals.completedDeals.length > 0 ? (
              deals.completedDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 p-4 shadow-md mb-4 "
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet{" "}
                    <span className="text-gray-400">Fixed</span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal?.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal?.property?.name}</p>
                      <p className="text-gray-500">
                        {deal?.currentStage?.name}
                      </p>
                    </div>
                    <div>
                      <p className="font-bold">
                        {deal.dealFollowup?.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal?.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">Completed</p>
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal.dealFollowup.completedTime
                        ).toLocaleDateString()}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="border rounded-lg w-5/6 p-4 shadow-md">
                <p>No completed deals.</p>
              </div>
            ))}

          {activeTab === "Lost" &&
            (deals.lostDeals && deals.lostDeals.length > 0 ? (
              deals.lostDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 p-4 shadow-md mb-4"
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet{" "}
                    <span className="text-gray-400"></span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal.property?.name}</p>
                      <p className="text-gray-500">{deal.currentStage?.name}</p>
                    </div>
                    <div className="truncate">
                      <p className="font-bold text-ellipsis">
                        {deal.dealFollowup.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">Deal Lost</p>
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal.dealFollowup.lostTime
                        ).toLocaleDateString()}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="border rounded-lg w-5/6 p-4 shadow-md">
                <p>No lost deals.</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default LeadDeals;
